import Vue from 'vue';
import VueRouter from 'vue-router';

const Index = () => import(/* webpackChunkName:'Index' */ '@pages/Index/Index.vue');
const Home = () => import(/* webpackChunkName:'home' */ '@pages/Home/Index.vue');
const ApplySeal = () => import(/* webpackChunkName:'ApplySeal' */ '@pages/ApplySeal/Index.vue');
const LocalizationPlan = () => import(/* webpackChunkName:'LocalizationPlan' */ '@pages/LocalizationPlan/Index.vue');
const About = () => import(/* webpackChunkName:'About' */ '@pages/About/Index.vue');
const ProductIndex = () => import(/* webpackChunkName:'Product' */ '@pages/Product/Index.vue');
const SealSoftware = () => import(/* webpackChunkName:'SealSoftware' */ '@pages/Product/SealSoftware.vue');
const SealMaterial = () => import(/* webpackChunkName:'SealMaterial' */ '@pages/Product/SealMaterial.vue');
const SealingEquipment = () => import(/* webpackChunkName:'SealingEquipment' */ '@pages/Product/SealingEquipment.vue');
const ResourcesDownload = () => import(/* webpackChunkName:'Down' */ '@pages/download/Index.vue');
const ContactUs = () => import(/* webpackChunkName:'ContactUs' */ '@pages/About/ContactUs.vue');
const EsealIndex = () => import(/* webpackChunkName:'Eseal' */ '@pages/eseal/Index.vue');
const LnzcIndex = () => import(/* webpackChunkName:'lnzc' */ '@pages/lnzc/Index.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Index,
  },
  {
    path: '/Home',
    component: Home,
  },
  {
    path: '/ApplySeal',
    component: ApplySeal,
  },
  {
    path: '/lnzc',
    component: LnzcIndex,
  },
  {
    path: '/LocalizationPlan',
    component: LocalizationPlan,
  },
  {
    path: '/About',
    component: About,
  },
  {
    path: '/ContactUs',
    component: ContactUs,
  },
  {
    path: '/eseal',
    component: EsealIndex,
  },
  {
    path: '/Product',
    component: ProductIndex,
  },
  {
    path: '/Product/SealMaterial',
    component: SealMaterial,
  },
  {
    path: '/Product/SealSoftware',
    component: SealSoftware,
  },
  {
    path: '/Product/SealingEquipment',
    component: SealingEquipment,
  },
  {
    path: '/ResourcesDownload',
    component: ResourcesDownload,
  },
];

const router = new VueRouter({
  routes,
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
